import { getColor, transparentize, mode } from '@chakra-ui/theme-tools';
const getBaseStyle = (props) => {
    const { theme } = props;
    return {
        closeButton: {
            cursor: 'inherit',
        },
        opaque: {
            display: 'inline-block',
            borderRadius: 'full',
            bg: mode('white', 'gray.600')(props),
        },
        container: {
            lineHeight: 1.2,
            outline: 'none',
            fontWeight: 'normal',
            transition: 'all 250ms',
            _disabled: {
                cursor: 'not-allowed',
                bg: mode(transparentize('gray.300', 0.16)(theme), transparentize('blue.100', 0.12)(theme))(props),
                color: mode(transparentize('gray.600', 0.36)(theme), transparentize('white', 0.36)(theme))(props),
            },
        },
    };
};
const graySolidStyle = (props) => {
    const { theme } = props;
    return {
        container: {
            color: mode('gray.600', 'white')(props),
            bg: mode(transparentize(`gray.300`, 0.16)(theme), transparentize(`blue.100`, 0.16)(theme))(props),
            ...(props.onClick || props.onChange
                ? {
                    cursor: 'pointer',
                    _hover: {
                        bg: mode(transparentize(`gray.300`, 0.32)(theme), transparentize(`blue.100`, 0.24)(theme))(props),
                    },
                    _active: {
                        bg: mode(transparentize(`gray.300`, 0.48)(theme), transparentize(`blue.100`, 0.32)(theme))(props),
                    },
                    _checked: {
                        boxShadow: 'none',
                        bg: mode('blue.500', 'blue.400')(props),
                        color: mode('white', 'gray.600')(props),
                    },
                    _focus: {
                        boxShadow: mode(`0 0 0 1px ${getColor(theme, 'blue.600')}, ` +
                            `0 0 0 5px ${transparentize('blue.400', 0.24)(theme)}`, `inset 0 0 0 1px ${transparentize('white', 0.16)(theme)}, ` +
                            `0 0 0 1px ${getColor(theme, 'blue.300')}, ` +
                            `0 0 0 5px ${transparentize(`blue.400`, 0.24)(theme)}`)(props),
                        ':focus:not(:focus-visible)': {
                            boxShadow: 'none',
                        },
                        ':focus:not(:-moz-focusring)': {
                            boxShadow: 'none',
                        },
                    },
                }
                : {}),
        },
    };
};
const getSolidStyle = (props) => {
    const { colorScheme, theme } = props;
    if (colorScheme === 'gray') {
        return graySolidStyle(props);
    }
    return {
        container: {
            bg: mode(`${colorScheme}.500`, `${colorScheme}.400`)(props),
            color: mode(`white`, `rgba(0, 0, 0, 0.87)`)(props),
            ...(props.onClick
                ? {
                    _hover: { bg: mode(`${colorScheme}.600`, `${colorScheme}.300`)(props) },
                    _active: { bg: mode(`${colorScheme}.700`, `${colorScheme}.200`)(props) },
                    _focus: {
                        boxShadow: mode(`0 0 0 1px ${transparentize(`${colorScheme}.600`, 1.0)(theme)}, 0 0 0 5px ${transparentize(`${colorScheme}.400`, 0.24)(theme)}`, `0 0 0 1px ${transparentize(`${colorScheme}.300`, 1.0)(theme)}, 0 0 0 5px ${transparentize(`${colorScheme}.400`, 0.24)(theme)}`)(props),
                    },
                }
                : {}),
        },
    };
};
const sizes = {
    sm: {
        closeButton: {
            ml: 1,
            mr: '-0.25rem',
            fontSize: '2xl',
        },
        container: {
            minHeight: 6,
            height: 6,
            minWidth: 6,
            fontSize: 'md',
            paddingX: 2,
            paddingY: '0.125rem',
            borderRadius: 'full',
        },
    },
    md: {
        closeButton: {
            ml: '0.375rem',
            mr: '-0.375rem',
            fontSize: '2xl',
        },
        container: {
            minHeight: '1.875rem',
            height: '1.875rem',
            minWidth: 8,
            fontSize: 'md',
            paddingX: 3,
            paddingY: '0.3125rem',
            borderRadius: 'full',
        },
    },
};
const parts = ['container', 'label', 'closeButton'];
const defaultProps = {
    size: 'md',
    colorScheme: 'gray',
    variant: 'solid',
};
const variants = {
    solid: getSolidStyle,
};
export default {
    parts,
    baseStyle: getBaseStyle,
    sizes,
    defaultProps,
    variants,
};
//# sourceMappingURL=tag.js.map